export function initCookie() {
  if (document.cookie.includes("cookieConsent=accepted")) {
    return;
  }

  const cookieBanner = document.querySelector("[data-cookie]") as HTMLDivElement;

  const acceptButton = cookieBanner.querySelector("[data-cookie-accept]") as HTMLButtonElement;
  const closeButton = (cookieBanner.querySelector("[data-cookie-close]") as HTMLButtonElement) ?? null;

  acceptButton.addEventListener("click", (): void => {
    setCookie("cookieConsent", "accepted", 30);
    cookieBanner.classList.add("cookie-consent-hidden");
    setTimeout(() => {
      cookieBanner.remove();
    }, 400);
  });

  if (closeButton) {
    closeButton.addEventListener("click", (): void => {
      cookieBanner.classList.add("cookie-consent-hidden");
      setTimeout(() => {
        cookieBanner.remove();
      }, 400);
    });
  }

  setTimeout(() => {
    cookieBanner.classList.remove("cookie-consent-hidden");
  }, 300);

  function setCookie(name: string, value: string, days: number) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }
}
